import React, { useState } from 'react';
import { FiPlus, FiUser } from 'react-icons/fi';
import CRMSidebar from '../components/CRMSidebar';
import GenericAddModal from '../components/GenericAddModal';
import useLocalState from '../hooks/useLocalState';
import { sortData } from '../utils/tableUtils';

const initialData = [];

export default function Contacts() {
  const [data, setData] = useLocalState('contacts_data', initialData);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [sortConfig, setSortConfig] = useState({ key: 'ref', direction: 'asc' });

  const handleAdd = (newData) => setData([newData, ...data]);
  const handleSort = (key) => setSortConfig({ key, direction: sortConfig.key === key && sortConfig.direction === 'asc' ? 'desc' : 'asc' });
  const sortedData = sortData(data, sortConfig);

  return (
    <div className="flex h-full font-sans overflow-hidden bg-white">
      <CRMSidebar />
      <div className="flex-1 flex flex-col bg-[#a6e4e7] p-2">
        <div className="flex justify-between items-center mb-3 px-1">
          <div className="flex items-center space-x-2">
            <FiUser className="text-xl text-teal-800" />
            <span className="font-medium text-[15px] text-teal-700">Contacts ({data.length})</span>
          </div>
          <button onClick={() => setIsModalOpen(true)} className="bg-[#0000a0] text-white p-1.5 rounded hover:bg-blue-900"><FiPlus /></button>
        </div>
        <div className="flex-1 overflow-x-auto bg-white border border-black">
          <table className="min-w-full border-collapse text-[12px]">
            <thead>
              <tr className="bg-[#a6e4e7] text-teal-900">
                <th onClick={() => handleSort('ref')} className="p-2 border border-black text-left cursor-pointer">Ref.</th>
                <th onClick={() => handleSort('firstname')} className="p-2 border border-black text-left cursor-pointer">First Name</th>
                <th onClick={() => handleSort('lastname')} className="p-2 border border-black text-left cursor-pointer">Last Name</th>
                <th className="p-2 border border-black text-left">Email</th>
                <th className="p-2 border border-black text-left">Phone</th>
              </tr>
            </thead>
            <tbody>
              {sortedData.map((row, idx) => (
                <tr key={idx} className="hover:bg-blue-50">
                  <td className="p-2 border border-black">{row.ref}</td>
                  <td className="p-2 border border-black">{row.firstname}</td>
                  <td className="p-2 border border-black">{row.lastname}</td>
                  <td className="p-2 border border-black">{row.email}</td>
                  <td className="p-2 border border-black">{row.phone}</td>
                </tr>
              ))}
              {sortedData.length === 0 && <tr><td colSpan="5" className="p-4 text-center text-gray-500">No records found</td></tr>}
            </tbody>
          </table>
        </div>
        <GenericAddModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} onAdd={handleAdd} title="Add Contact" fields={[
          { name: 'ref', label: 'Reference' }, { name: 'firstname', label: 'First Name' }, { name: 'lastname', label: 'Last Name' },
          { name: 'email', label: 'Email' }, { name: 'phone', label: 'Phone' }
        ]} />
      </div>
    </div>
  );
}